
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.644 6.644l4.746-4.627a1.147 1.147 0 000-1.661 1.147 1.147 0 00-1.661 0L5.813 4.153 2.017.356a1.147 1.147 0 00-1.661 0C.118.593 0 .83 0 1.186c0 .238.118.594.356.831l4.746 4.627c.355.475 1.186.475 1.542 0z","fill":"#A5BCE0"}})])
          )
        }
      }
    